import React from "react";
import { IIconStatus, IconStatusTypeClass, IconStatusTypeDescription, IconStatusTypeComponent } from '../../interfaces/Components/IconStatus/IIconStatus';

import './IconStatus.scss';

export const IconStatus = ({ iconType }: IIconStatus) => {

    const containerClassName = `icon-status ${IconStatusTypeClass[iconType]}`
    return (
        <div data-testid="icon-status" className={containerClassName}>
            {IconStatusTypeComponent[iconType]}
            <span data-testid="status-text" className="status-text">{IconStatusTypeDescription[iconType]}</span>
        </div>
    );
}
